import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.products;

export default class Products extends Model {
  static entity = `${name}`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      technology: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/products',
    },
  };
}
